import {memo} from 'react'
import { NavLink } from 'react-router-dom'
import ContactForm from '../ContactForm'

function Footer() {
    return(
        <div>
            <ContactForm />
            <footer>
                <h2>Enlaces</h2>
                <div className="border-top">&nbsp;</div>
                <div className="d-flex flex-wrap justify-content-between align-items-center">
                    <ul>
                        <li><NavLink to="/legal/terms-and-conditions" title="Abrir los Términos y condiciones">Términos y condiciones</NavLink></li>
                        <li><NavLink to="/legal/privacy-policy" title="Abrir las Políticas de Privacidad">Políticas de Privacidad</NavLink></li>
                    </ul>
                </div>
                <div className="d-flex flex-wrap justify-content-between align-items-center">
                    <div className="container">
                        <br/>
                        <p className="text-center">Recuerde a tus seres queridos por siempre con Remember Me</p>
                    </div>
                </div>
            </footer>
        </div>
    )
}

export default memo(Footer)